import Vue from 'vue'
import HomePage from './HomePage.vue'

Vue.config.productionTip = false

new Vue({
  render: (h) => h(HomePage)
}).$mount('#page')
